module.exports = __webpack_public_path__ + "static/images/ui/ui-bg_inset-soft_25_000000_1x100.png";